document.addEventListener('DOMContentLoaded', function () {
  // DOM elements
  const departmentTabsContainer = document.getElementById('department-tabs');
  const departmentSelect = document.getElementById('department-select');
  const teamRow = document.getElementById('team-row');

  // Fetch team data from the server-side endpoint (which now handles caching)
  fetchTeamData();

  // Helper function to populate the UI using fetched data
  function loadTeamData(data) {
    const departments = data.webFeedMtt.departments;
    const users = data.webFeedMtt.users;

    // Loop through each department to create desktop tabs and mobile options
    for (const deptId in departments) {
      // Create desktop tab
      const tabButton = document.createElement('li');
      tabButton.className = 'department-tab';
      tabButton.textContent = departments[deptId];
      tabButton.addEventListener('click', function () {
        activateDepartment(deptId, this, users);
      });
      departmentTabsContainer.appendChild(tabButton);

      // Create mobile option
      const option = document.createElement('option');
      option.value = deptId;
      option.textContent = departments[deptId];
      departmentSelect.appendChild(option);
    }

    // Mobile select change event
    departmentSelect.addEventListener('change', function () {
      const selectedDeptId = this.value;
      document.querySelectorAll('.department-tab').forEach(tab => tab.classList.remove('active'));
      activateDepartment(selectedDeptId, null, users);
    });

    // Activate the first tab/option by default
    const firstTab = document.querySelector('.department-tab');
    if (firstTab) {
      firstTab.click();
      departmentSelect.selectedIndex = 0;
    }

    // Hide the loader
    document.getElementById('custom-loader-overlay').style.display = 'none';
  }

  // Function to fetch data from the API endpoint
  function fetchTeamData() {
    fetch('https://api-shopify.enveseur.com/meet-the-team/data')
      .then(response => response.json())
      .then(data => {
        loadTeamData(data);
      })
      .catch(error => {
        console.error('Error fetching team data:', error);
        document.getElementById('custom-loader-overlay').style.display = 'none';
      });
  }
});

/**
 * Loads users by department.
 * @param {string} deptId - The department ID.
 * @param {Element|null} clickedTab - The clicked tab element (if any).
 * @param {Object} users - The users object from the API.
 */
function activateDepartment(deptId, clickedTab, users) {
  const teamRow = document.getElementById('team-row');

  if (clickedTab) {
    document.querySelectorAll('.department-tab').forEach(el => el.classList.remove('active'));
    clickedTab.classList.add('active');
  }

  teamRow.innerHTML = '';

  if (users[deptId]) {
    for (const userIndex in users[deptId]) {
      const userObj = users[deptId][userIndex];
      const userCard = document.createElement('div');
      userCard.className = 'user-card custom-border-radius-8';

      // Image
      const userImage = document.createElement('img');
      userImage.src = 'https://res.cloudinary.com/env-cloud/c_fill,f_auto,fl_force_strip,g_face,h_600,q_auto,r_max,w_600/team/' + userObj.image;
      userImage.alt = userObj.firstname + ' ' + userObj.lastname;

      // Name
      const userName = document.createElement('h5');
      userName.textContent = `${userObj.firstname} ${userObj.lastname}`;

      // Job title
      const userTitle = document.createElement('p');
      userTitle.className = 'job-title';
      userTitle.textContent = userObj.job_title ? decodeHtmlEntities(userObj.job_title) : '';

      // Email
      const userEmail = document.createElement('p');
      userEmail.className = 'email';
      userEmail.textContent = userObj.email || '';

      userCard.appendChild(userImage);
      userCard.appendChild(userName);
      userCard.appendChild(userTitle);
      userCard.appendChild(userEmail);
      teamRow.appendChild(userCard);
    }
  } else {
    teamRow.innerHTML = '<p>No team members found in this department.</p>';
  }
}

/**
 * Decodes HTML entities in a string.
 * @param {string} str - Input string with HTML entities.
 * @returns {string} - Decoded string.
 */
function decodeHtmlEntities(str) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
}